export default {
  BASE_URL: '',
  FRIDAY_TRACKER_ID: '',
  // 高德地图安全代理（已弃用，保留用于回滚）
  AMAP_SERCURITY_HOST: `${location.origin}/_AMapService`,
};



// WEBPACK FOOTER //
// ./src/config/config.test.js